import type { PayloadAction } from '@reduxjs/toolkit';
import type { ModalsState } from 'shared/interfaces/modal.interface';

import { createSlice } from '@reduxjs/toolkit';
import {
  ASSIGN_AGENCY_MODAL,
  ASSIGN_DIVISION_MODAL,
  ASSIGN_PEOPLE_MODAL,
  MODAL_AGENCY,
  MODAL_CONFIG_FULL,
  MODAL_DIVISION,
  MODAL_PEOPLE,
  MODAL_POLICY,
  MODAL_USER,
} from 'shared/constants/modals';

const initialState: ModalsState = [
  {
    name: MODAL_POLICY,
    isOpen: false,
    data: null,
  },
  {
    name: ASSIGN_AGENCY_MODAL,
    isOpen: false,
    data: null,
  },
  {
    name: MODAL_AGENCY,
    isOpen: false,
    data: null,
  },
  {
    name: ASSIGN_DIVISION_MODAL,
    isOpen: false,
    data: null,
  },
  {
    name: MODAL_DIVISION,
    isOpen: false,
    data: null,
  },
  { name: ASSIGN_PEOPLE_MODAL, isOpen: false, data: null },
  { name: MODAL_PEOPLE, isOpen: false, data: null },
  { name: MODAL_USER, isOpen: false, data: null },
  { name: MODAL_CONFIG_FULL, isOpen: false, data: null },
];

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<{ name: string; data?: any }>) => {
      const { name, data } = action.payload;

      const modalIndex = state.findIndex((modal) => modal.name === name);

      if (modalIndex !== -1) {
        state[modalIndex].isOpen = true;
        state[modalIndex].data = data;
      } else {
        state.push({ name, isOpen: true, data });
      }
    },
    closeModal: (
      state,
      action: PayloadAction<{ name: string; data?: any }>,
    ) => {
      const { name, data } = action.payload;

      const modalIndex = state.findIndex((modal) => modal.name === name);

      if (modalIndex !== -1) {
        state[modalIndex].isOpen = false;
        state[modalIndex].data = data;
      } else {
        state.push({ name, isOpen: false, data });
      }
    },
  },
});

export const { openModal, closeModal } = modalsSlice.actions;

export const modalsReducer = modalsSlice.reducer;
